import flatpickr from "flatpickr";
import { Polish } from "flatpickr/dist/l10n/pl";
import { eventsCarousel } from "./Slider";
//import { KD } from "./KD";

export class Datepicker {
	constructor() {
		this.init();
	}

	init() {
		flatpickr.localize(Polish);
		flatpickr.setDefaults({
			disableMobile: true,
		});

		const newsDatepicker = $('#newsDatepicker');
		const newsGlownaDatepicker = $('#newsGlownaDatepicker');
		const eventsDatepicker = $('#eventsDatepicker');
		const imprezyListaDatepicker = $('#imprezyDatepicker');

		//const kd = new KD();

		flatpickr(newsDatepicker, {
			onChange: function () {
				//console.log('news - ' + newsDatepicker.val())
			},
		});
		flatpickr(newsGlownaDatepicker, {
			onChange: function () {
				//console.log('news - ' + newsMainDatepicker.val())
				window.location.href = '/' + newsGlownaDatepicker.attr('data-link') + '/' + newsGlownaDatepicker.val() + '/';
			},
		});
		flatpickr(eventsDatepicker, {
			onChange: function () {
//                console.log('imprezy' + eventsDatepicker.val())
				kdSgImp(eventsDatepicker.val(), 1);
			},
		});
		flatpickr(imprezyListaDatepicker, {
			onChange: function () {

				window.location.href = '/' + imprezyListaDatepicker.attr('data-link') + '/' + imprezyListaDatepicker.val() + '/';
				//console.log(imprezyListaDatepicker.attr('data-link'))
				//console.log('imprezy' + imprezyListaDatepicker.val())
			},
		});
	}
}